import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(list)/styles',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/my-styles/styles' ||
      location.pathname === '/my-styles/styles/'
    ) {
      throw redirect({ to: '/my-styles/styles/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/StylesLayout'),
    'StylesLayout',
  ),
});
